module.exports = __webpack_public_path__ + "img/b4_bingjinghuankui.ede7f017.jpg";